import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Form, Input, Select } from 'antd'
import { debounce } from 'lodash'
import { GET_UNIT_PAGE, MPMUnitVO } from '@/api/MaterialApi'

interface Props {
  value?: string
  onChange?: (value: string, options: any) => void
  placeholder?: string
  disabled?: boolean
  allowClear?: boolean
  style?: React.CSSProperties
  className?: string
}

const UnitSelect: FC<Props> = ({
  value,
  onChange,
  placeholder = '请选择单位',
  disabled = false,
  allowClear = true,
  style,
  className,
}) => {
  const [options, setOptions] = useState<MPMUnitVO[]>([])
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [pageNo, setPageNo] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  // 获取单位列表
  const fetchUnits = useCallback(
    async (name?: string, page = 1, isLoadMore = false) => {
      try {
        setLoading(true)
        const response = await GET_UNIT_PAGE({
          name,
          pageNo: page,
          pageSize: 10,
        })

        if (response.code === 0 && response.data) {
          const newOptions = response.data.content || []
          setOptions((prev) =>
            isLoadMore ? [...prev, ...newOptions] : newOptions,
          )
          setHasMore(newOptions.length === 10)
        }
      } catch (error) {
        console.error('获取单位列表失败:', error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  // 防抖搜索
  const debouncedSearch = useMemo(
    () =>
      debounce((searchText: string) => {
        setPageNo(1)
        fetchUnits(searchText, 1, false)
      }, 300),
    [fetchUnits],
  )

  // 初始化加载
  useEffect(() => {
    fetchUnits()
  }, [fetchUnits])

  // 处理搜索
  const handleSearch = (searchText: string) => {
    setSearchValue(searchText)
    debouncedSearch(searchText)
  }

  // 处理下拉框滚动加载更多
  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e
    const element = target as HTMLDivElement
    if (
      element.scrollTop + element.offsetHeight === element.scrollHeight &&
      hasMore &&
      !loading
    ) {
      const nextPage = pageNo + 1
      setPageNo(nextPage)
      fetchUnits(searchValue, nextPage, true)
    }
  }

  // 处理下拉框显示/隐藏
  const handleDropdownVisibleChange = (open: boolean) => {
    if (open && options.length === 0) {
      fetchUnits()
    }
  }

  return (
    <>
      <Select
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        allowClear={allowClear}
        style={style}
        className={className}
        showSearch
        filterOption={false}
        loading={loading}
        onSearch={handleSearch}
        onPopupScroll={handlePopupScroll}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        notFoundContent={loading ? '加载中...' : '暂无数据'}
      >
        {options.map((unit) => (
          <Select.Option
            key={unit.unit || unit.name}
            value={unit.unit || unit.name}
          >
            {unit.name}
          </Select.Option>
        ))}
      </Select>
      <Input type="hidden" value={value} />
    </>
  )
}

export default UnitSelect
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Form, Input, Select } from 'antd'
import { debounce } from 'lodash'
import { GET_UNIT_PAGE, MPMUnitVO } from '@/api/MaterialApi'

interface Props {
  value?: string
  onChange?: (value: string, options: any) => void
  placeholder?: string
  disabled?: boolean
  allowClear?: boolean
  style?: React.CSSProperties
  className?: string
}

const UnitSelect: FC<Props> = ({
  value,
  onChange,
  placeholder = '请选择单位',
  disabled = false,
  allowClear = true,
  style,
  className,
}) => {
  const [options, setOptions] = useState<MPMUnitVO[]>([])
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [pageNo, setPageNo] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  // 获取单位列表
  const fetchUnits = useCallback(
    async (name?: string, page = 1, isLoadMore = false) => {
      try {
        setLoading(true)
        const response = await GET_UNIT_PAGE({
          name,
          pageNo: page,
          pageSize: 10,
        })

        if (response.code === 0 && response.data) {
          const newOptions = response.data.content || []
          setOptions((prev) =>
            isLoadMore ? [...prev, ...newOptions] : newOptions,
          )
          setHasMore(newOptions.length === 10)
        }
      } catch (error) {
        console.error('获取单位列表失败:', error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  // 防抖搜索
  const debouncedSearch = useMemo(
    () =>
      debounce((searchText: string) => {
        setPageNo(1)
        fetchUnits(searchText, 1, false)
      }, 300),
    [fetchUnits],
  )

  // 初始化加载
  useEffect(() => {
    fetchUnits()
  }, [fetchUnits])

  // 处理搜索
  const handleSearch = (searchText: string) => {
    setSearchValue(searchText)
    debouncedSearch(searchText)
  }

  // 处理下拉框滚动加载更多
  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e
    const element = target as HTMLDivElement
    if (
      element.scrollTop + element.offsetHeight === element.scrollHeight &&
      hasMore &&
      !loading
    ) {
      const nextPage = pageNo + 1
      setPageNo(nextPage)
      fetchUnits(searchValue, nextPage, true)
    }
  }

  // 处理下拉框显示/隐藏
  const handleDropdownVisibleChange = (open: boolean) => {
    if (open && options.length === 0) {
      fetchUnits()
    }
  }

  return (
    <>
      <Select
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        allowClear={allowClear}
        style={style}
        className={className}
        showSearch
        filterOption={false}
        loading={loading}
        onSearch={handleSearch}
        onPopupScroll={handlePopupScroll}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        notFoundContent={loading ? '加载中...' : '暂无数据'}
      >
        {options.map((unit) => (
          <Select.Option
            key={unit.unit || unit.name}
            value={unit.unit || unit.name}
          >
            {unit.name}
          </Select.Option>
        ))}
      </Select>
      <Input type="hidden" value={value} />
    </>
  )
}

export default UnitSelect
